import { render, staticRenderFns } from "./CreateEventAsset.vue?vue&type=template&id=13fbfeb2&scoped=true"
import script from "./CreateEventAsset.vue?vue&type=script&lang=js"
export * from "./CreateEventAsset.vue?vue&type=script&lang=js"
import style0 from "./CreateEventAsset.vue?vue&type=style&index=0&id=13fbfeb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fbfeb2",
  null
  
)

export default component.exports